export default "__VITE_ASSET__CjlywvJg__"